export const getLocalizationContext = (isMultiCurrency) => {
  return isMultiCurrency ? 'part' : 'site'
}
